import React from 'react';
import { getSchoolColor } from './designSystem';

/**
 * PositionIndicator - Shows competitive position with gradient bar and marker
 * Matches mockup's position bar design
 */
const PositionIndicator = ({
  index = 0,
  percentage = 75,
  label = '75th percentile',
  title = 'Your Position',
  description = 'Among admitted students with similar profiles'
}) => {
  const colors = getSchoolColor(index);

  return (
    <div className="mb-6">
      {/* Label Row */}
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-slate-700">{title}</span>
        <span className="text-sm font-bold text-slate-900">{label}</span>
      </div>

      {/* Position Bar */}
      <div className={`relative h-3 ${colors.positionBg} rounded-full overflow-visible`}>
        {/* Gradient Fill */}
        <div
          className={`absolute inset-0 bg-gradient-to-r ${colors.gradient} rounded-full transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        />

        {/* Position Marker */}
        <div
          className={`absolute -top-1 w-0.5 h-5 ${colors.marker} bg-current rounded-sm transition-all duration-500`}
          style={{ left: `${percentage}%`, transform: 'translateX(-50%)' }}
        />
      </div>

      {/* Description */}
      {description && (
        <p className="text-xs text-slate-500/90 mt-2">{description}</p>
      )}
    </div>
  );
};

export default PositionIndicator;
